<template>
    <div>
        <v-card class="fill-height" elevation="0">
            <v-card color="#D4C88D" elevation="0" height="100px" class="d-flex align-content-end">
                <v-card-title class="white--text text-h5">
                    <v-icon color="white" large>mdi-bullhorn-outline</v-icon>
                    &nbsp;Announcements
                </v-card-title>
            </v-card>
            <v-card-text>
                Announcements are displayed in the student interface after successful authentication. 
                Different <b>types</b> of announcements will be displayed in different places of the student portal. <br />
                <AnnouncementsManager />
            </v-card-text>
        </v-card>
        <iframe name="hiddenFrame" hidden></iframe>
    </div>
</template>
<script>
import AnnouncementsManager from "../../../components/Admin/Announcements/Manager.vue"

export default {
    components: {
        AnnouncementsManager
    }
}
</script>